<template>
  <div class="menu_wrap" @click="onHideMenu">
    <div
      :class="{
        menu: true,
        menu_windows: $store.state.client == 'windows',
      }"
    >
      <div class="menu_list" @mouseleave="onHideMenu">
        <div
          class="menu_item menu_item_user"
          @click="goUser"
          v-if="!$store.getters.isAppstoreMode && $store.state.user.uid"
        >
          个人中心
        </div>
        <div
          class="menu_item menu_item_change"
          @click="goServerPage"
          v-if="
            !$store.getters.isAppstoreMode &&
            ($store.state.client == 'mac' ||
              $store.state.client == 'windows') &&
            $store.state.version > '2.3.2'
          "
        >
          设备绑定码
        </div>
        <!-- <div class="menu_item_hr"></div>
        <div
          class="menu_item menu_item_mall"
          @click="goMall"
          v-if="!$store.getters.isAppstoreMode && $store.state.user.uid"
        >
          小宝商城
        </div> -->
        <div class="menu_item_hr"></div>
        <div class="menu_item menu_item_phone" @click="goPhone" v-if="false">
          手机版
          <div class="phone_tips">
            <div class="phone_tips_text">即将上线</div>
          </div>
        </div>

        <div
          class="menu_item menu_item_download"
          @click="goDownload"
          v-if="!$store.getters.isAppstoreMode"
        >
          下载小宝
        </div>
        <div class="menu_item_hr"></div>
        <div
          class="menu_item menu_item_exchange"
          @click="goExchange"
          v-if="!$store.getters.isAppstoreMode && $store.state.user.uid"
        >
          兑换礼品
        </div>
        <div class="menu_item_hr"></div>
        <div
          class="menu_item menu_item_help"
          @click="goHelp"
          v-if="!$store.getters.isAppstoreMode"
        >
          帮助中心
        </div>
        <div class="menu_item_hr"></div>
        <div class="menu_item menu_item_about" @click="goAbout">关于小宝</div>
        <div class="menu_item_hr"></div>
        <div
          class="menu_item menu_item_logout"
          @click="myLogoutClick"
          v-if="$store.state.user.uid"
        >
          退出登录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["sendUserlog"]),
    goServerPage: function () {
      let _that = this;
      if (process.env.NODE_ENV !== "production") {
        // window.location.href =
        //   "http://192.168.71.34:8083/?client=" +
        //   _that.$store.state.client +
        //   "&version=" +
        //   _that.$store.state.version;
        window.location.href =
          "http://yc.iepose.com/jdxb_server_pc_v4/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      } else {
        window.location.href =
          "http://yc.iepose.com/jdxb_server_pc_v4/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      }
    },
    showLogin: function () {
      this.$store.state.isShowLogin = true;
    },
    hideLogin: function () {
      this.$store.state.isShowLogin = false;
    },
    goExchange: function () {
      this.$store.state.isShowPayExchange = true;
    },
    goUser: function () {
      let _that = this;
      _that.sendUserlog(["menu_user", ""]);
      if (!_that.$store.state.user.uid) {
        _that.showLogin();
        return;
      }
      _that.$router.push("/home/userinfo");
    },
    goMall: function () {
      let _that = this;
      _that.sendUserlog(["menu_mall", ""]);
      if (!_that.$store.state.user.uid) {
        _that.showLogin();
        return;
      }
      _that.$router.push("/home/mall");
    },
    goPhone: function () {
      let _that = this;
      _that.sendUserlog(["menu_phone", ""]);
    },
    goAbout: function () {
      let _that = this;
      _that.sendUserlog(["menu_about", ""]);
      _that.$router.push("/home/about");
    },
    goDownload: function () {
      let _that = this;
      _that.sendUserlog(["menu_download", ""]);
      _that.$router.push("/home/download");
    },
    goHelp: function () {
      let _that = this;
      _that.sendUserlog(["menu_help", ""]);
      _that.$router.push("/home/answer");
      //   _that.goUrl("https://jdxb.ionewu.com/jdxb/pc/support/about");
    },
    onHideMenu: function () {
      // console.log("onHideMenu");
      this.$emit("hideMenu");
    },
    myLogoutClick: function () {
      let _that = this;
      _that.sendUserlog(["logout", "menu"]);
      _that.$common.localStorage.removeItem("jdxb-uid");
      _that.$common.localStorage.removeItem("jdxb-openid");
      _that.$common.localStorage.removeItem("jdxb-name");
      _that.$common.localStorage.removeItem("jdxb-avatar");
      _that.$common.localStorage.removeItem("jdxb-owcode");
      _that.$common.localStorage.removeItem("jdxb-rkey");
      _that.$common.localStorage.removeItem("jdxb-phone");
      if (_that.$store.getters.isAppstoreMode) {
        _that.$router.push("/home/node");
      } else {
        _that.$router.push("/");
      }
      window.location.reload();
    },
    goUrl: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
  },
};
</script>

<style lang="less" scoped>
.menu_wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 90;
}

.menu {
  width: 145px;
  position: absolute;
  right: 10px;
  top: 40px;
  background-image: url("../../assets/common/menu/bg.svg");
  background-size: 100% auto;
  // box-shadow: 0px 5px 5px #aaa;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  .menu_list {
    width: 145px;
    margin-top: 6px;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0px 8px 16px rgba(123, 130, 134, 0.24);
  }
  .menu_item {
    width: 145px;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    color: #666666;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 50px;
    text-align: left;
    background-color: #ffffff;
  }
  .menu_item:hover {
    cursor: pointer;
    color: #1f5de3;
    font-weight: bolder;
    background-color: #f0f6ff;
  }
  .menu_item_hr {
    width: 125px;
    height: 1px;
    background-image: url("../../assets/common/menu/menu_item_hr.svg");
    background-size: 100% 100%;
    margin: 0 auto;
  }
  .menu_item_user {
    height: 40px;
    padding-top: 4px;
    background-image: url("../../assets/common/menu/user_gray.svg");
    background-position: 25px 14px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
  }
  .menu_item_user:hover {
    background-image: url("../../assets/common/menu/user.svg");
  }
  .menu_item_mall {
    background-image: url("../../assets/common/menu/mall_gray.svg");
    background-position: 25px 10px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
  }
  .menu_item_mall:hover {
    background-image: url("../../assets/common/menu/mall.svg");
  }

  .menu_item_phone {
    background-image: url("../../assets/common/menu/phone_gray.svg");
    background-position: 25px 9px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
    position: relative;

    .phone_tips {
      width: 45px;
      height: 17px;
      line-height: 17px;
      text-align: center;
      color: #ffffff;
      font-size: 9px;
      background-image: url("../../assets/common/menu/phone_tips.svg");
      background-size: 100% 100%;
      position: absolute;
      right: 7px;
      top: 4px;
      .phone_tips_text {
        color: #ffffff;
        width: 50px;
        transform: scale(0.7);
        transform-origin: left center;
        margin-left: 4px;
      }
    }
  }
  .menu_item_phone:hover {
    background-image: url("../../assets/common/menu/phone.svg");
    .phone_tips {
      color: #ffffff;
    }
  }

  .menu_item_help {
    background-image: url("../../assets/common/menu/help_gray.svg");
    background-position: 25px 9px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
  }
  .menu_item_help:hover {
    background-image: url("../../assets/common/menu/help.svg");
  }

  .menu_item_change {
    background-image: url("../../assets/common/menu/change_gray.svg");
    background-position: 25px 9px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
  }
  .menu_item_change:hover {
    background-image: url("../../assets/common/menu/change.svg");
  }

  .menu_item_download {
    background-image: url("../../assets/common/menu/download_gray.svg");
    background-position: 25px 9px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
  }
  .menu_item_download:hover {
    background-image: url("../../assets/common/menu/download.svg");
  }

  .menu_item_exchange {
    background-image: url("../../assets/common/menu/pay_exchange.svg");
    background-position: 26px 10px;
    background-repeat: no-repeat;
    background-size: 15px 15px;
  }

  .menu_item_exchange:hover {
    background-image: url("../../assets/common/menu/pay_exchange_active.svg");
    background-position: 26px 10px;
    background-repeat: no-repeat;
    background-size: 15px 15px;
  }

  .menu_item_about {
    background-image: url("../../assets/common/menu/about_gray.svg");
    background-position: 25px 10px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
  }
  .menu_item_about:hover {
    background-image: url("../../assets/common/menu/about2.svg");
  }

  .menu_item_logout {
    background-image: url("../../assets/common/menu/logout_gray.svg");
    background-position: 25px 9px;
    background-repeat: no-repeat;
    background-size: 17px 17px;
    height: 40px;
  }
  .menu_item_logout:hover {
    background-image: url("../../assets/common/menu/logout.svg");
  }
}

.menu_windows {
  right: 97px;
}
</style>